
import Component from 'vue-class-component';
import Vue from 'vue';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import chartExplainer1Gif from '@/assets/images/Gif1.gif';
import chartExplainer2Gif from '@/assets/images/Gif2.gif';
import chartExplainer3Gif from '@/assets/images/Gif3.gif';

const charts = [
	{
		active: true,
		gif: chartExplainer1Gif,
		id: 2,
		buttonText: 'Next',
	},
	{
		active: false,
		id: 3,
		gif: chartExplainer2Gif,
		buttonText: 'Next',
	},
	{
		active: false,
		id: 4,
		gif: chartExplainer3Gif,
		buttonText: 'Got it!',
	},
];

@Component
export default class LoanTakeBackExplainModal extends Vue {
	public activeChart = charts[0];

	public activeChartGif = '';

	public charts = charts;

	@Prop({ default: false })
	public isLoading!: boolean;

	public isShown = false;

	@Prop({ default: false })
	public state!: boolean;

	get isLastChart(): boolean {
		return this.activeChart.id === charts[charts.length - 1].id;
	}

	@Emit('complete')
	// eslint-disable-next-line class-methods-use-this
	public emitComplete(): boolean {
		return true;
	}

	public close(): void {
		this.emitComplete();
		this.isShown = false;
	}

	mounted() {
		this.setChartGif();
	}

	public onNext(): void {
		if (this.isLastChart) {
			this.emitComplete();
			return;
		}

		const activeChartId = this.activeChart.id;
		const nextId = activeChartId + 1;
		const activeChart = this.charts.find((gif) => gif.id === nextId);

		this.activeChart = activeChart ?? charts[0];
		this.setChartGif();
	}

	public onPaginationClick(chart: any): void {
		this.activeChart = chart;
		this.setChartGif();
	}

	public setChartGif(): void {
		const key = +new Date();
		this.activeChartGif = `${this.activeChart.gif}?key=${key}`;
	}

	@Watch('state')
	public watchState(state: boolean): void {
		this.onPaginationClick(this.charts[0]);
		this.isShown = state;
	}
}
